import { Area } from '@antv/g2plot';
import { useEffect, useRef, useState } from "react";
import { Tooltip, mapData, getLegend } from './helper';
import { getRange } from '../../../Modules/pme/screens/dashboard/widgets/mitigation-actions-trend/helper';

export default function useChart({ data, t }) {
  const container = useRef();
  const [graph, setGraph] = useState(null);
  const [metricsValues, setMetricsValues] = useState([]);

  useEffect(() => {
    if (data) {
      setMetricsValues(getLegend(data));
    }
  }, [data]);

  useEffect(() => {
    const _metricsValues = metricsValues.sort((a, b) => b.sort - a.sort);
    const mappedData = mapData(data, _metricsValues);
    const _data = mappedData;

    if (data && metricsValues.length > 0) {
      const color = _metricsValues
        .filter((c) => c.toggled)
        .map((c) => c.color);


      if (!graph) {
        const area = new Area(container.current, {
          data: _data,
          xField: 'type',
          seriesField: 'series',
          yField: 'value',
          animation: false, 
          color,
          legend: false,
          xAxis: {
            label: {
              formatter: () => '',
            },
            nice: true,
            tickLine: {
              style: {
                opacity: 0,
              }
            }
          },
          yAxis: {
            tickMethod: (a) => getRange(a.max),
          },
          tooltip: {
            customContent: (_, data) => {
              if (data[0]) {
                if ((data[0].title || '_').indexOf('_') === -1) {
                  return Tooltip(data, t);
                }
              }
            },
          },
          point: {
            shape: 'round',
            size: 4,
            style: (a) => {
              const val = _metricsValues.find((m) => m.key === a.series);
              if (val) {
                const color = val.color;
                return {
                  fill: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : 'white',
                  stroke: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : color,
                  lineWidth: 2,
                };
              }
            },
          },
          areaStyle: {
            fillOpacity: 0.7,
          }
        });
        setGraph(area);
        area.render();
      } else {
        graph.update({
          data: _data,
          animation: false,
          color,
          point: {
            shape: 'round',
            size: 4,
            style: (a) => {
              const val = _metricsValues.find((m) => m.key === a.series);
              if (val) {
                const color = val.color;
                return {
                  fill: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : 'white',
                  stroke: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : color,
                  lineWidth: 2,
                };
              }
            },
          },
          areaStyle: {
            fillOpacity: 0.9,
          }
        });
      }
    }
  }, [data, metricsValues]);

  return {
    container,
    metricsValues,
    setMetricsValues,
  }
}
